import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from "../../services/authentication.service";
import {ApiService} from "../../services/api.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  username = '';
  isNavbarCollapsed: boolean;

  constructor(
    private authService: AuthenticationService,
    private apiService: ApiService,
    private router: Router
  ) {
  }

  ngOnInit() {
    let username = localStorage.getItem('username');
    this.username = username
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  canUserSignDoc() {
    return this.authService.isAccountant();
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  isUIH() {
    return this.authService.isUIH();
  }

  isAccountant() {
    return this.authService.isAccountant();
  }

  isAccountantAdmin() {
    return this.authService.isAccountantAdmin();
  }

  isIT() {
    return this.authService.isIT();
  }

  isViewer() {
    return this.authService.isViewer();
  }

  isViewerAudit() {
    return this.authService.isViewerAudit();
  }

  getUsername() {
    return localStorage.getItem('username')
  }

  getRole() {
    return localStorage.getItem('group')
  }

  isSystemAdmin() {
    return this.authService.isSystemAdmin();
  }

  hasViewDocumentRequestPermission() {
    return this.authService.hasRequestDeletePermission() || this.authService.hasRequestEditPermission();
  }

  logout() {
    this.apiService.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
    this.sniff('LOGOUT', this.username);
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'HOME',
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.ts